module.exports = __webpack_public_path__ + "h5/img/addwork-icon.f47040d2.png";